import i18n from "../assets/i18n/config";

export const catchGraphQlErrors = (error) => {
    return i18n.t(error.graphQLErrors[0].code);
};
